export default __webpack_public_path__ + "static/media/thumb_9.91909d05.webp";